// extracted by mini-css-extract-plugin
export default {"wrapper":"NotificationMessage_wrapper__ShDBr","success":"NotificationMessage_success__nXPq9","error":"NotificationMessage_error__iS-To"};